import React from 'react';
import { ArrowRightIcon, CalendarIcon } from 'lucide-react';
export function CallToAction() {
  return <section className="py-16 border-t border-black" data-id="element-17">
      <div className="bg-gradient-to-r from-orange-900 to-black p-8 rounded-lg text-center" data-id="element-18">
        <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-19">
          Es Tu Momento de Decisión
        </h2>
        <p className="text-lg mb-8 max-w-3xl mx-auto" data-id="element-20">
          Cada día que pasa sin un sistema de conversión efectivo, estás dejando
          dinero sobre la mesa.
          <span className="font-bold text-orange-400" data-id="element-21">
            {' '}
            Las plazas son limitadas para garantizar atención personalizada.
          </span>
        </p>
        <div className="flex items-center justify-center mb-8" data-id="element-22">
          <ArrowRightIcon className="h-8 w-8 text-orange-500 mr-2 animate-pulse" data-id="element-23" />
          <span className="text-xl font-bold" data-id="element-24">
            Reserva tu llamada estratégica gratuita ahora
          </span>
          <ArrowRightIcon className="h-8 w-8 text-orange-500 ml-2 animate-pulse" data-id="element-25" />
        </div>
        <button className="bg-orange-500 hover:bg-orange-600 text-black font-bold py-5 px-10 rounded-full text-2xl transition-all transform hover:scale-105 flex items-center justify-center mx-auto mb-6" data-id="element-26">
          <CalendarIcon className="h-6 w-6 mr-2" data-id="element-27" />
          Agendar mi llamada estratégica
        </button>
        <p className="text-sm text-gray-300" data-id="element-28">
          Plazas limitadas para atención personalizada
        </p>
      </div>
      <div className="mt-12 text-center" data-id="element-29">
        <p className="text-lg font-bold text-orange-300 mb-2" data-id="element-30">
          AI Persuasion Bootcamp
        </p>
        <p className="text-xl font-extrabold text-orange-400" data-id="element-31">
          El Sistema Conversión Instantánea
        </p>
        <p className="mt-4 text-sm text-gray-400" data-id="element-32">
          © 2023 Gabriel Beltrán. Todos los derechos reservados.
        </p>
      </div>
    </section>;
}